(function(){
  'use strict';

  // ===== TOAST =====
  window.blToast = function(msg){
    var el = document.getElementById('bl-toast');
    if (!el) { el = document.createElement('div'); el.id = 'bl-toast'; el.className = 'bl-toast'; document.body.appendChild(el); }
    el.textContent = msg;
    el.hidden = false;
    el.classList.add('is-show');
    clearTimeout(window.__blToastTimer);
    window.__blToastTimer = setTimeout(function(){
      el.classList.remove('is-show');
      setTimeout(function(){ el.hidden = true; }, 250);
    }, 2400);
  };

  // ===== CART HELPERS (Shopify-native) =====
  function fetchCart(){
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function(r){ return r.json(); });
  }
  function refreshBadge(count){
    document.querySelectorAll('[data-cart-count]').forEach(function(el){
      el.textContent = count;
      el.classList.toggle('is-active', count > 0);
    });
  }
  function money(cents){
    return 'R$ ' + (cents/100).toFixed(2).replace('.', ',');
  }

  // ===== DRAWER =====
  function ensureDrawer(){
    if (document.getElementById('bl-drawer')) return;
    var d = document.createElement('div');
    d.id = 'bl-drawer';
    d.className = 'bl-drawer';
    d.hidden = true;
    d.innerHTML =
      '<div class="bl-drawer__backdrop" data-bl-cart-close></div>' +
      '<aside class="bl-drawer__panel" aria-label="Sacola">' +
        '<header class="bl-drawer__head"><h3>Sua sacola</h3><button class="bl-drawer__close" data-bl-cart-close aria-label="Fechar">×</button></header>' +
        '<div class="bl-drawer__body" id="bl-drawer-body"></div>' +
        '<footer class="bl-drawer__foot" id="bl-drawer-foot"></footer>' +
      '</aside>';
    document.body.appendChild(d);
    d.addEventListener('click', function(e){
      if (e.target.closest('[data-bl-cart-close]')) window.blCloseCart();
    });
  }

  function renderDrawer(cart){
    ensureDrawer();
    var body = document.getElementById('bl-drawer-body');
    var foot = document.getElementById('bl-drawer-foot');
    if (cart.item_count === 0){
      body.innerHTML = '<div class="bl-drawer__empty"><div class="bl-drawer__empty-ico">🛍️</div><p>Sua sacola está vazia.</p><a href="/collections/all" class="bl-btn bl-btn--primary" data-bl-cart-close>Ver produtos</a></div>';
      foot.innerHTML = '';
      return;
    }
    body.innerHTML = cart.items.map(function(i, idx){
      var img = i.image ? '<img src="'+i.image.replace(/(\.[^.]+)$/, '_120x$1')+'" alt="" style="width:100%;height:100%;object-fit:cover;border-radius:10px">' : (i.product_title.charAt(0).toUpperCase());
      var variant = (i.variant_title && i.variant_title !== 'Default Title') ? '<div class="bl-line__sub" style="font-size:11.5px;color:#7a6a64;margin-top:-2px;margin-bottom:6px">'+i.variant_title+'</div>' : '';
      return '<div class="bl-line">' +
        '<a href="'+i.url+'" class="bl-line__media">'+img+'</a>' +
        '<div class="bl-line__info">' +
          '<div class="bl-line__name"><a href="'+i.url+'" style="color:inherit;text-decoration:none">'+i.product_title+'</a></div>' +
          variant +
          '<div class="bl-line__price">'+money(i.final_price)+'</div>' +
          '<div class="bl-line__qty">' +
            '<button data-bl-qty="'+(idx+1)+'" data-bl-delta="-1">−</button>' +
            '<span>'+i.quantity+'</span>' +
            '<button data-bl-qty="'+(idx+1)+'" data-bl-delta="1">+</button>' +
          '</div>' +
        '</div>' +
        '<button class="bl-line__rm" data-bl-rm="'+(idx+1)+'" aria-label="Remover">×</button>' +
      '</div>';
    }).join('');

    var freeThreshold = 40000;
    var faltam = freeThreshold - cart.total_price;
    var freeBar = cart.total_price >= freeThreshold
      ? '<div class="bl-cart__free is-on" style="margin-bottom:12px">🎉 Você ganhou <strong>frete grátis</strong>!</div>'
      : '<div class="bl-cart__free" style="margin-bottom:12px">Faltam <strong>'+money(faltam)+'</strong> para frete grátis<div class="bl-cart__bar"><span style="width:'+Math.min(100, (cart.total_price/freeThreshold)*100)+'%"></span></div></div>';

    foot.innerHTML =
      freeBar +
      '<div class="bl-drawer__total"><span>Total</span><strong>'+money(cart.total_price)+'</strong></div>' +
      '<a href="/cart" class="bl-btn bl-btn--ghost" style="width:100%;margin-bottom:10px">Ver sacola completa</a>' +
      '<a href="/checkout" class="bl-btn bl-btn--primary" style="width:100%">Finalizar compra</a>';

    foot.querySelectorAll('[data-bl-qty]').forEach(function(b){
      b.addEventListener('click', function(){
        var line = +b.getAttribute('data-bl-qty');
        var delta = +b.getAttribute('data-bl-delta');
        var current = cart.items[line-1].quantity;
        changeCart(line, current + delta);
      });
    });
    body.querySelectorAll('[data-bl-rm]').forEach(function(b){
      b.addEventListener('click', function(){ changeCart(+b.getAttribute('data-bl-rm'), 0); });
    });
  }

  function changeCart(line, qty){
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function(r){ return r.json(); }).then(function(cart){
      refreshBadge(cart.item_count);
      renderDrawer(cart);
      var cp = document.getElementById('bl-cart-page'); if (cp) location.reload();
    });
  }

  window.blOpenCart = function(){
    ensureDrawer();
    fetchCart().then(function(cart){
      refreshBadge(cart.item_count);
      renderDrawer(cart);
      var d = document.getElementById('bl-drawer');
      d.hidden = false;
      requestAnimationFrame(function(){ d.classList.add('is-open'); });
      document.body.style.overflow = 'hidden';
    });
  };
  window.blCloseCart = function(){
    var d = document.getElementById('bl-drawer');
    if (!d) return;
    d.classList.remove('is-open');
    setTimeout(function(){ d.hidden = true; }, 300);
    document.body.style.overflow = '';
  };

  // ===== QUICK ADD (Compra Rápida from card) =====
  window.blQuickAdd = function(variantId, productTitle){
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    }).then(function(r){ return r.json(); }).then(function(){
      fetchCart().then(function(cart){
        refreshBadge(cart.item_count);
        window.blToast((productTitle || 'Produto') + ' adicionado à sacola');
        window.blOpenCart();
      });
    }).catch(function(){
      window.blToast('Não foi possível adicionar. Tente novamente.');
    });
  };

  // ===== HEADER CART CLICK → DRAWER =====
  document.addEventListener('click', function(e){
    var a = e.target.closest('[data-bl-cart-open]');
    if (a && location.pathname !== '/cart'){
      e.preventDefault();
      window.blOpenCart();
    }
  });

  // ===== INIT =====
  fetchCart().then(function(cart){ refreshBadge(cart.item_count); }).catch(function(){});
})();
